
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class SequenceGrid extends _Ext.GridBase<SequenceRow, any> {
        protected getColumnsKey() { return 'Administration.Sequence'; }
        protected getDialogType() { return SequenceDialog; }
        protected getIdProperty() { return SequenceRow.idProperty; }
        protected getInsertPermission() { return SequenceRow.insertPermission; }
        protected getLocalTextPrefix() { return SequenceRow.localTextPrefix; }
        protected getService() { return SequenceService.baseUrl; }

        constructor(container: JQuery, options) {
            super(container, options);
        }
    }
}